import { render, staticRenderFns } from "./NestedMenu.vue?vue&type=template&id=123634d6&scoped=true&"
import script from "./NestedMenu.vue?vue&type=script&lang=js&"
export * from "./NestedMenu.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./NestedMenu.vue?vue&type=style&index=0&id=123634d6&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "123634d6",
  null
  ,true
)

export default component.exports